/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".create-new-signer-link[_ngcontent-%COMP%]{float:right;position:relative}.signers[_ngcontent-%COMP%]{text-align:left}"];
export { styles as styles };
